const Common = {

    // BUTTON
    "add": "Create",
    "submit": "Save",
    "apply": "Apply",
    "clear": "Clear",
    "cancel": "Cancel",
    "ok": "Ok",
    "save_next": "Save & Next",
    "close": "Close",
    "details": "Details",
    "confirm": "Confirm",

    // PAGE HEADER
    "filter": "Filter",

    // TOOLTIP
    "download": "Download",
    "pdf": "PDF",
    "excel": "Excel",
    "edit": "Edit",
    "delete": "Delete",

    // TOAST
    "success_add": "Created Successfully",
    "success_update": "Edited Successfully",
    "wrong": "Something went wrong",

    // SWEET ALERT
    "confirm_text": "Are You Sure Want To Delete?",
    "delete_text": "Deleted Successfully",

    // TABLE HEADER
    "table_no": "NO",
    "table_action": "ACTION",

    // PAGINATION
    "page_size": "Page Size",
    "previous": "Previous",
    "next": "Next",

}

export default Common;